import G_NA from './NA';
import G_EU from './EU';
import { useGlobal } from '@/utils/useGlobal';

export default function G() {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es'];

    return <>{EU_SITES?.includes(locale) ? <G_EU /> : <G_NA />}</>;
}
